var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.261,
    height: 22.261,
    viewBox: "0 0 22.261 22.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grid",
    d: "M1,3.332A2.332,2.332,0,0,1,3.332,1H7.995a2.332,2.332,0,0,1,2.332,2.332V7.995a2.332,2.332,0,0,1-2.332,2.332H3.332A2.332,2.332,0,0,1,1,7.995Zm2.332-.777a.777.777,0,0,0-.777.777V7.995a.777.777,0,0,0,.777.777H7.995a.777.777,0,0,0,.777-.777V3.332a.777.777,0,0,0-.777-.777Zm10.1.777A2.332,2.332,0,0,1,15.766,1h4.663a2.332,2.332,0,0,1,2.332,2.332V7.995a2.332,2.332,0,0,1-2.332,2.332H15.766a2.332,2.332,0,0,1-2.332-2.332Zm2.332-.777a.777.777,0,0,0-.777.777V7.995a.777.777,0,0,0,.777.777h4.663a.777.777,0,0,0,.777-.777V3.332a.777.777,0,0,0-.777-.777ZM1,15.766a2.332,2.332,0,0,1,2.332-2.332H7.995a2.332,2.332,0,0,1,2.332,2.332v4.663a2.332,2.332,0,0,1-2.332,2.332H3.332A2.332,2.332,0,0,1,1,20.429Zm2.332-.777a.777.777,0,0,0-.777.777v4.663a.777.777,0,0,0,.777.777H7.995a.777.777,0,0,0,.777-.777V15.766a.777.777,0,0,0-.777-.777Zm10.1.777a2.332,2.332,0,0,1,2.332-2.332h4.663a2.332,2.332,0,0,1,2.332,2.332v4.663a2.332,2.332,0,0,1-2.332,2.332H15.766a2.332,2.332,0,0,1-2.332-2.332Zm2.332-.777a.777.777,0,0,0-.777.777v4.663a.777.777,0,0,0,.777.777h4.663a.777.777,0,0,0,.777-.777V15.766a.777.777,0,0,0-.777-.777Z",
    transform: "translate(-0.75 -0.75)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.b7064e21519570384e9a111bc946147a.svg";
export { ForwardRef as ReactComponent };